/**
 * Format numbers with Swiss locale (apostrophe separator)
 */
export const formatNumberCH = (
  value: number,
  decimals: number | "auto" = 0,
  locale = "de-CH"
): string => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "";

  // Auto mode: no decimals for integers, 1 decimal otherwise
  let decimalsToUse: number = typeof decimals === "number" ? decimals : 0;
  if (decimals === "auto") {
    decimalsToUse = Number.isInteger(n) ? 0 : 1;
  }

  try {
    return n.toLocaleString(locale, {
      minimumFractionDigits: decimalsToUse,
      maximumFractionDigits: decimalsToUse,
    });
  } catch {
    // Fallback: manual apostrophe grouping
    const parts = n.toFixed(Math.max(0, decimalsToUse)).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    return parts.join(".");
  }
};

/**
 * Sanitize string for use as object key or CSS class
 */
export const sanitizeKey = (s: unknown): string => {
  const str = String(s ?? "Unknown")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
  return str.replace(/\s+/g, "_").replace(/[^\w]/g, "_");
};
